import { HomeComponent } from '../Components/home';
import { ProductDetailComponent } from '../Components/product.detail';
import { ProductListComponent } from '../Components/product.list';
import { BrandListComponent } from '../Components/brand.list';
import { BrandDetailComponent } from '../Components/brand.detail';
import { CategoryListComponent } from '../Components/category.list';
import { CartDetailComponent } from '../Components/cart.detail';
import { CollectionListComponent } from '../Components/collection.list';
import { ProductCreateComponent } from '../Components/product.create';
import { ProductUpdateComponent } from '../Components/product.update';
import { PageComponent } from '../Components/page';
import { PageNotFoundComponent } from '../Components/pagenotfound';
import { LoginComponent } from '../Components/login';
import { RegisterComponent } from '../Components/register';
import { RequestPwdComponent } from '../Components/requestpwd';
import { PasswordResetComponent } from '../Components/password.reset';
import { ProfileComponent } from '../Components/profile';
import { InboxComponent } from '../Components/inbox';
import { CheckoutComponent } from '../Components/checkout';
import { OrderComponent } from '../Components/order';


export const AppRoutes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'products/create',
    component: ProductCreateComponent
  },
  {
    path: 'products/:id/edit',
    component: ProductUpdateComponent
  },
  {
    path: 'products/:id',
    component: ProductDetailComponent
  },
  {
    path: 'shop',
    component: ProductListComponent
  },
  {
    path: 'brands',
    component: BrandListComponent
  },
  {
    path: 'brands/:name',
    component: BrandDetailComponent
  },
  {
    path: 'categories',
    component: CategoryListComponent
  },
  {
    path: 'collections',
    component: CollectionListComponent
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'requestpwd',
    component: RequestPwdComponent,
  },
  {
    path: 'resetpwd/:uid/:token',
    component: PasswordResetComponent,
  },
  {
    path: 'profile',
    component: ProfileComponent,
  },
  // Allow navigation to specific tab in profile
  {
    path: 'profile/:frag',
    component: ProfileComponent,
  },
  //{
    //path: 'cart',
    //component: CartDetailComponent,
  //},
  {
    path: 'inbox',
    component: InboxComponent,
  },
  {
    path: 'pages/:id',
    component: PageComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
  },
  {
    path: 'order/:id',
    component: OrderComponent,
  },
  //{
  //  path: '',
  //  redirectTo: '/',
  //  pathMatch: 'full'
  //},
  { path: '**', component: PageNotFoundComponent }
];



// WEBPACK FOOTER //
// ./src/app/Routes/app.routes.ts